// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuIcon-module--root--1Wc6U","icon":"MenuIcon-module--icon--1kZFJ","light":"MenuIcon-module--light--2pQ_-"};